module.exports = __webpack_public_path__ + "img/facebook-logo.bba44943.svg";